import {MDBContainer, MDBCol, MDBRow, MDBBtn, MDBIcon, MDBInput } from 'mdb-react-ui-kit';
import { Field, Form, Formik } from 'formik';

export const metadata = {
    title: 'Sign Up - Open PRO',
    description: 'Page description',
  }

  export default function SignUp() {

  // const onHide=()=>{
  //     setreg(true)
  // }
  
    return (
      <MDBContainer>
         
        <>
      <MDBRow>

      <MDBCol col='10' md='6'>
        <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp" class="img-fluid" alt="Sample" />
      </MDBCol>

      <MDBCol col='4' md='6'>

        <div className="d-flex flex-row align-items-center justify-content-center">

          <p className="lead fw-normal mb-0 me-3 p-2">Enter Your Details</p>
        </div>

        {/* <div className="divider d-flex align-items-center my-4">
          <p className="text-center fw-bold mx-3 mb-0">Or</p>
        </div> */}
          <Formik initialValues={{first_name:"",last_name:"",email:"",phone_number:"",password:"",more_info:""}} onSubmit={async (values)=>{
            
            const initials = values.first_name.charAt(0).toUpperCase() + values.last_name.charAt(0).toUpperCase();
            const moreinfo = {
              dpname: initials,
              notification: values.more_info,
              profilenotification: ""
            };
            
            const alldata = {
              ...values,
              subscription: "invalid",
              duration: "demo",
              section: "website",
              moreinfo: JSON.stringify(moreinfo) 
            };
            console.log("values",alldata)
            const apiurl = "https://thk9n7oewa.execute-api.ap-south-1.amazonaws.com/firstdeploy/adduser";
            
            try {
              const response = await fetch(apiurl, {
                mode: 'no-cors',
                method: "POST",
                headers: {
                  "Content-Type": "application/json" // Corrected headers object
                },
                body: JSON.stringify(alldata)
              });
            
              // if (!response.ok) {
              //   throw new Error('Network response was not ok');
              // }
            
              const responseData = await response.json();
              console.log("response", responseData);
            } catch (error) {
              console.error('There was a problem with the fetch operation:', error.message);
            }
            
           
          }} >
            {({setFieldValue})=>(
              
          
            <Form>
        <div style={{display:"flex",flexDirection:"row"}}>
        
        <Field required as={MDBInput} name="first_name" wrapperClass='mb-4' label='First Name' className='mr-3' id='formControlLg' type='first_name' size="lg" />
        <Field required as={MDBInput} name="last_name" wrapperClass='mb-4' label='Last Name' id='formControlLg' className='ml-3' type='last_name' size="lg" />
        </div>
        
        <Field required as={MDBInput} name="phone_number" wrapperClass='mb-4' label='Mobile Number' id='formControlLg' type='mobile number' size="lg" />
        <Field required as={MDBInput} name="email" wrapperClass='mb-4' label='Email address' id='formControlLg' type='email' size="lg" />
        <Field required as={MDBInput} name="password" wrapperClass='mb-4' label='Password' id='formControlLg' type='password' size="lg" />
        <Field required as={MDBInput} name="more_info" wrapperClass='mb-4' label='Your Enquiry'  id='formControlLg' type='textarea' size='lg' />
        {/* <div className="d-flex justify-content-between mb-4">
          <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' />
          <a href="!#">Forgot password?</a>
        </div> */}

        <div className='text-center text-md-start mt-4 pt-2'>
          <button style={{backgroundColor:"blanchedalmond",border:0,borderRadius:"10px",padding:"10px"}} className="m-3 px-5" size='lg' type='Submit'>Send Enquiry</button>
          {/* <p className="small fw-bold mt-2 pt-1 mb-2">All Ready Registered? 
          <a href="#!" onClick={onHide} className="link-danger">Login</a></p> */}
        </div>
        </Form>
          )}
        </Formik>
      </MDBCol>

    </MDBRow>
    
    <div className="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-4 px-4 px-xl-5 bg-primary">

        <div className="text-white mb-3 mb-md-0">
          Copyright © 2024. All rights reserved.
        </div>

        <div>

          <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
            <MDBIcon fab icon='facebook-f' size="md" />
          </MDBBtn>

          <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
            <MDBIcon fab icon='twitter' size="md" />
          </MDBBtn>

          <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
            <MDBIcon fab icon='google' size="md" />
          </MDBBtn>

          <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
            <MDBIcon fab icon='linkedin-in' size="md" />
          </MDBBtn>

        </div>

      </div>
      </>
  
     </MDBContainer>
    )
  }
  